import { useQuery } from '@tanstack/react-query';
import { api, MOCK_MODE } from '../api';
import { fetchReplay, type ReplayResponse } from '../api/replay';

export function useReplay(sessionId: string | null) {
  return useQuery<ReplayResponse>({
    queryKey: ['replay', sessionId],
    queryFn: () => {
      if (!sessionId) {
        return Promise.reject(new Error('No sessionId'));
      }
      // Demo mode has no backend: the mock client rebuilds the run from the
      // in-memory audit trail so Replay works on the standalone build too.
      if (MOCK_MODE && 'getReplay' in api) {
        return api.getReplay(sessionId);
      }
      return fetchReplay(sessionId);
    },
    enabled: !!sessionId,
    staleTime: 60_000,
  });
}
